import { LanguageOptions } from "./Base/LanguageOptions";

enum GAMETYPE_ID {
  MANHUNT = "manhunt",
  QUEST = "quest",
}

export interface GameType {
  name: LanguageOptions;
  slug: string;
  season: Season;
  v_prefix: string;
}

export interface Season {
  fx: { [key: string]: FX };
  imgs: string[];
  inv_items: { [key: string]: InvItem };
  minigameStyle?: MiniGameStyle;
  name: LanguageOptions;
  intro: {
    intro_img?: string;
    intro_t: LanguageOptions;
    intro_audio?: LanguageOptions;
    intro_video?: LanguageOptions;
  };
  outro: {
    outro_img?: string;
    outro_t: LanguageOptions;
    outro_audio?: LanguageOptions;
    outro_video?: LanguageOptions;
  };
  slug: string;
  weapons: { [key: string]: Weapon };
  teamSizeOverride: number;
  is_edit: boolean;
  notes: LanguageOptions;
}

export interface InvItem {
  type?: string;
  desc?: LanguageOptions;
  img: string;
  name: LanguageOptions;
  quant: number;
  shown: boolean;
  slug: string;
  recipes?: { [key: string]: Recipes };
}

export interface MiniGameStyle {
  [name: string]: {
    code: { [key: number]: string };
  };
}

export interface Recipes {
  items: {
    [inv_slug: string]: { quant: number; name: LanguageOptions; slug: string };
  };
}

export interface FX {
  desc: string;
  slug: string;
}

export interface Weapon {
  desc?: LanguageOptions;
  img: string;
  name: LanguageOptions;
  guilt: boolean;
  uid: string;
}

export { GAMETYPE_ID };
